import { render, staticRenderFns } from "./redPackageAudit.vue?vue&type=template&id=2593c504&scoped=true&"
import script from "./redPackageAudit.vue?vue&type=script&lang=js&"
export * from "./redPackageAudit.vue?vue&type=script&lang=js&"
import style0 from "./redPackageAudit.vue?vue&type=style&index=0&id=2593c504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593c504",
  null
  
)

component.options.__file = "redPackageAudit.vue"
export default component.exports